// Older forms saved a missing value as the text "null" or "undefined"; both mean nothing was recorded.
export const isSavedAsEmpty = (text: string): boolean => ["null", "undefined"].includes(text.trim().toLowerCase());
